import { NgModule } from '@angular/core';
import {
  NoPreloading,
  PreloadAllModules,
  RouterModule,
  Routes,
} from '@angular/router';
import { PRELOAD_MODULES } from './core/config/constants';
import { routerErrorHandler } from './core/factories/router-error-handler.factory';
import { DownloadComponent } from './download/download.component';
import { NotFoundComponent } from './not-found/not-found.component';

const appRoutes: Routes = [
  { path: '', loadChildren: './dashboard/dashboard.module#DashboardModule' },
  { path: 'download/:appType', component: DownloadComponent },
  { path: '404', component: NotFoundComponent },
];

const preloadingStrategy = PRELOAD_MODULES ? PreloadAllModules : NoPreloading;

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      errorHandler: routerErrorHandler,
      preloadingStrategy,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/app-routing.module.ts